"use client";
import { useId, useState } from "react";
export default function EntertainmentNewsletter({ heading = "Get the latest stories delivered", description = "Subscribe for updates from this publication." }) {
  const id = useId();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  async function submit(event) {
    event.preventDefault(); if (busy) return;
    const form = event.currentTarget;
    setBusy(true); setMessage("");
    try {
      const response = await fetch("/api/newsletter/subscribers", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: new FormData(form).get("email") }) });
      if (!response.ok) throw new Error("Subscription could not be completed. Check your address or try again later.");
      form.reset(); setMessage("Thank you for subscribing.");
    } catch { setMessage("Subscription could not be completed. Check your address or try again later."); }
    finally { setBusy(false); }
  }
  return <section className="ent-newsletter"><h2>{heading}</h2><p>{description}</p><form onSubmit={submit}><label htmlFor={id}>Email address</label><input id={id} name="email" type="email" autoComplete="email" required placeholder="Enter your email" /><button disabled={busy}>{busy ? "Subscribing…" : "Subscribe"}</button></form><p>Read our <a href="https://surgezircmedia.com/p/privacy-policy">Privacy Policy</a>.</p><p role="status">{message}</p></section>;
}
